<template>
    <toolbar-option>
        <template slot="primary">
            <div class="f-events">
                <span class="f-events__text">
                    {{ message }}
                </span>

                <button class="f-events__button" type="button" @click="onClick">
                    MANAGE
                </button>
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import baseOption from '@/options/mixins/base-option';
import { FlexEventGroup } from '@/data/data-models';
import { SHOW_DRAWER } from '@/store/types/mutation-types';

const CUSTOM_ATTR_NAME = 'flex-event-group';

export default {
    name: 'flex-events',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Flex Events',
        };
    },

    computed: {
        ...mapState({
            selectedElements: state => state.page.selectedElements,
        }),

        flexEventGroup() {
            return this.selectedElements[0] && this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME)
                ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME)
                : new FlexEventGroup();
        },

        message() {
            const len = Object.values(this.flexEventGroup).flat().length;

            switch (len) {
                case 0:
                    return 'No events found.';

                case 1:
                    return `${ len } event found.`;

                default:
                    return `${ len } events found.`;
            }
        },
    },

    methods: {
        ...mapMutations({
            showDrawer: SHOW_DRAWER,
        }),

        onClick() {
            this.showDrawer('drawer-flex-events');
        },
    },
};
</script>

<style lang="scss" scoped>
.f-events {
    &__text {
        display: block;
        margin-bottom: 1.75em;
        font-size: 0.875rem;
    }

    &__button {
        @extend %button-alt;
        @extend %button-compact;
    }
}
</style>
